import * as React from "react";
import StoreMap from "./store-map";
import StoreList from "./store-list";
export default class ShoppingList extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { stores, selected, updateSelected, mapOptions, showList, products, shoppingList, clusters, amenitesFilter } = this.props;
        return (React.createElement("div", { className: "store-results" },
            React.createElement(StoreList, { getLocation: this.props.getLocation, stores: stores, selected: selected, amenitesFilter: amenitesFilter, updateFilter: this.props.updateFilter, updateSelected: updateSelected, toggleList: this.props.toggleList, MarkerClick: this.props.MarkerClick, clearFilter: this.props.clearFilter, updateAddressText: this.props.updateAddressText }),
            React.createElement(StoreMap, { showList: showList, mapOptions: mapOptions, stores: stores, clusters: clusters, products: products, shoppingList: shoppingList, selected: selected, updateSelected: updateSelected, handleMapChange: this.props.handleMapChange, clusterMarkerClick: this.props.clusterMarkerClick })));
    }
}
;
//# sourceMappingURL=store-results.js.map